import { render } from "./_form-content.vue?vue&type=template&id=07b91a3e&lang=pug"
import script from "./_form-content.vue?vue&type=script&lang=js"
export * from "./_form-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__